import { styled } from '@mui/material';

export const ShowAllButtonWrapperStyled = styled('div')({
  maxWidth: '240px',
  position: 'relative',
  top: '85px',
  left: '42%',
  '@media (max-width: 743px)': {
    position: 'relative',
    top: '90px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 'fit-content',
  },

  '@media (min-width: 744px) and (max-width: 1199px)': {
    position: 'relative',
    top: '70px',
    left: '34%',
  },
});
